<div
  [id]="id"
  style="contain: paint style"
>
  @if (title) {
    <div class="px-5">
      <h2 class="pt-10 font-brand text-3xl text-base text-neutral-900">
        {{ title }}
      </h2>
    </div>
  }
  @if (heading) {
    <div class="mt-2 px-5">
      <p class="font-accent">{{ heading }}</p>
    </div>
  }
  @for (category of categories; track category) {
    <div class="mt-3 flex flex-col text-neutral-800">
      @if (category.title) {
        <div class="mt-2 px-5">
          <h3 class="font-accent text-2xl font-bold">{{ category.title }}</h3>
        </div>
      }
      @if (category.heading) {
        <div class="mt-3 px-5">
          <p class="font-accent">{{ category.heading }}</p>
        </div>
      }
      <div class="mt-3">
        <app-product-push-list-atom
          displayContext="marketplace_page"
          [products]="category.products"
          [tagColors]="tagColors"
          (requestGoToProduct)="requestGoToProduct($event, category.id)"
        ></app-product-push-list-atom>
      </div>
    </div>
  }
</div>
